export default "__VITE_ASSET__zOcKlcSZ__"